import { isSameId } from "../../helpers";
import { tempID } from "@xbs/lib-state";
export default function (store, ev) {
    const state = store.getState();
    const links = state.links;
    const id = ev.id || ev.link.id || tempID();
    if (links.find(storeLink => isSameId(id, storeLink.id)))
        return;
    const linkObj = {
        ...ev.link,
        id,
    };
    links.push(linkObj);
    store.setState({ links });
    ev.link = linkObj;
    ev.id = id;
    return () => {
        store.in.exec("delete-link", {
            id,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=add.js.map